export enum CompanyCreationFlow {
	Standalone = 1,
	SubCompany = 2,
}
